module.exports = __webpack_public_path__ + "media/fonts/sovremennic/SovremennicWide-Regular-7242c2973bc8696e202087db9f94538d.woff2";